//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { useEffect } from 'react';

import { useSmartInputContext } from '@components/molecules/smart-input/SmartInputContext';

/**
 * This component is rendered by a custom hashtag strategy when a `#` is typed.
 * It has the purpose of updating state so that the HashtagDropdown will be rendered.
 */

interface HashtagDropdownTriggerProps {
  children: React.ReactNode;
}

export const HashtagDropdownTrigger = ({
  children,
}: HashtagDropdownTriggerProps) => {
  const smartInputContext = useSmartInputContext();

  const isFocused = smartInputContext.editor.isFocused;

  /**
   * Only run the effect on mounting of the component so it does not reopen the dropdown
   * when it is closed from external methods
   */
  useEffect(() => {
    const hasRecommendedRecentHashtagsToShow = (
      smartInputContext.recommendedHashtags?.recommendedRecentHashtags ?? []
    ).some((tag) => tag.shouldShow);

    if (
      (hasRecommendedRecentHashtagsToShow ||
        smartInputContext.recommendedHashtags
          ?.isRecommendedAiHashtagsEnabled) &&
      isFocused
    ) {
      smartInputContext.recommendedHashtags?.setIsDropdownOpen(true, true);
    }
  }, []);

  return <>{children}</>;
};
